import { render, staticRenderFns } from "./VariableAttr.vue?vue&type=template&id=2ca0575d&scoped=true&"
import script from "./VariableAttr.vue?vue&type=script&lang=js&"
export * from "./VariableAttr.vue?vue&type=script&lang=js&"
import style0 from "./VariableAttr.vue?vue&type=style&index=0&id=2ca0575d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0575d",
  null
  
)

export default component.exports